import { h, Fragment, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./SpacingToken.module.css";

interface Props {
    class?: string;
    value: string;
    name?: ComponentChildren;
}

function SpacingToken({ class: cssClass, value, name }: Props) {
    return (
        <div class={classname(styles.spacingToken, cssClass, "caption-2 semibold")}>
            {name && (
                <>
                    <span class={classname(styles.name, "ellipsis")}>{name}</span>
                    <div class={styles.separator}/>
                </>
            )}
            <span>{value}</span>
        </div>
    );
}

export default SpacingToken;
